import { CaretLeftIcon } from "@radix-ui/react-icons";
import { Eye, EyeOffIcon } from "lucide-react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { getUserProfil, HOME, resetStorage } from "../../Utils/Utils";
import { EDIT_USER_CREDENTIALS } from "../../Utils/constant";
import { SubmitButton } from "../../components/Widget/SubmitButton";
import { logout, store } from "../../services/service";

const Profil = () => {
  const userInfo = getUserProfil();
  const [msg, setMsg] = useState(null);
  const [showOld, setShowOld] = useState(false);
  const [show, setShow] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [isSubmit, setIsSubmit] = useState(false);
  const navigate = useNavigate();
  const submit = (data) => {
    setIsSubmit(true);
    setMsg(null);
    store(EDIT_USER_CREDENTIALS, "application/json", {
      ...data,
      username: userInfo?.username,
    })
      .then((res) => {
        if (res.status === 200) {
          reset();
          setIsSubmit(null);
          toast.success("Mot de passe modifié");
          logout("/commerciale/user/logout").then(() => {
            resetStorage();
            navigate(`${HOME}/login`);
          });
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        setMsg(err?.response?.data?.donnee);
      });
  };

  return (
    <div className="">
      <div className="lg:flex gap-4 items-center">
        <button
          className="btn bg-white  btn-sm"
          onClick={() => {
            window.history.back();
          }}
        >
          <CaretLeftIcon />
        </button>
        <h1 className="text-3xl font-bold font-mtn">
          Modification de mot de passe
        </h1>
      </div>

      <div className="mt-8 rounded-xl w-full lg:w-fit p-4 bg-white mx-auto">
        <div class="space-y-6">
          <form class="space-y-2" onSubmit={handleSubmit(submit)}>
            <p className="text-red-500 text-sm">{msg}</p>
            <div class="">
              <label className="text-sm font-medium">
                Ancien mot de passe <span className="text-red-500">*</span>
              </label>

              <div className="mt-2 relative">
                <input
                  {...register("password", { required: true })}
                  type={showOld ? "text" : "password"}
                  placeholder="Ancien mot de passe"
                  className="input input-bordered w-full lg:w-96 h-10 text-sm "
                />
                {showOld ? (
                  <EyeOffIcon
                    onClick={() => setShowOld(!showOld)}
                    className="h-4 w-4 absolute right-3 top-3 text-slate-400 cursor-pointer"
                  />
                ) : (
                  <Eye
                    onClick={() => setShowOld(!showOld)}
                    className="h-4 w-4 absolute right-3 top-3 text-slate-400 cursor-pointer"
                  />
                )}
              </div>
            </div>

            <div class="">
              <label className="text-sm font-medium">
                Nouveau mot de passe <span className="text-red-500">*</span>
              </label>
              <div className="mt-2 relative">
                <input
                  {...register("newPassword", { required: true })}
                  type={show ? "text" : "password"}
                  placeholder="Nouveau mot de passe"
                  className="input input-bordered w-full lg:w-96 h-10 text-sm "
                />
                {show ? (
                  <EyeOffIcon
                    onClick={() => setShow(!show)}
                    className="h-4 w-4 absolute right-3 top-3 text-slate-400 cursor-pointer"
                  />
                ) : (
                  <Eye
                    onClick={() => setShow(!show)}
                    className="h-4 w-4 absolute right-3 top-3 text-slate-400 cursor-pointer"
                  />
                )}
              </div>
            </div>

            <div class="">
              <label className="text-sm font-medium">
                Confirmer le mot de passe{" "}
                <span className="text-red-500">*</span>
              </label>
              <div className="mt-2 relative">
                <input
                  {...register("passwordConfirm", { required: true })}
                  type={showConfirm ? "text" : "password"}
                  placeholder="Confirmer mot de passe"
                  className="input input-bordered w-full lg:w-96 h-10 text-sm "
                />
                {showConfirm ? (
                  <EyeOffIcon
                    onClick={() => setShowConfirm(!showConfirm)}
                    className="h-4 w-4 absolute right-3 top-3 text-slate-400 cursor-pointer"
                  />
                ) : (
                  <Eye
                    onClick={() => setShowConfirm(!showConfirm)}
                    className="h-4 w-4 absolute right-3 top-3 text-slate-400 cursor-pointer"
                  />
                )}
              </div>
            </div>

            <div className="mt-8">
              <SubmitButton isSubmit={isSubmit} label={"Modifier"} />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Profil;
